import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { useAuth } from '../../contexts/AuthContext'
import { LanguagePicker } from './LanguagePicker'

export const NavBar: React.FC = () => {
  const { user, logout, isRespondent } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <nav className="bg-surface border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="text-xl font-heading font-bold text-primary-dark">
              Sondely
            </Link>
            {/* Desktop nav links — hide Organizations for respondents */}
            {user && !isRespondent && (
              <Link to="/organizations" className="hidden sm:inline-block ml-6 text-sm font-medium text-foreground-muted hover:text-foreground transition-colors">
                <FormattedMessage id="nav.organizations" />
              </Link>
            )}
          </div>

          {/* Desktop right side */}
          <div className="hidden sm:flex items-center space-x-4">
            <span className="text-sm text-foreground-muted truncate max-w-[150px]">
              {user?.full_name || user?.email}
            </span>
            <LanguagePicker />
            <Link
              to="/settings/notifications"
              className="text-foreground-muted hover:text-foreground p-2 rounded-lg transition-colors"
              title="Notification Settings"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </Link>
            <button
              onClick={logout}
              className="text-sm text-foreground-muted hover:text-foreground px-3 py-2 rounded-lg transition-colors"
            >
              <FormattedMessage id="nav.signOut" />
            </button>
          </div>

          {/* Mobile hamburger */}
          <div className="flex sm:hidden items-center">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="p-2 rounded-lg text-foreground-muted hover:text-foreground transition-colors"
            >
              {menuOpen ? (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="sm:hidden border-t border-border bg-surface">
          <div className="px-4 py-3 space-y-1">
            {user && (
              <div className="pb-2 mb-2 border-b border-border-light">
                <p className="text-sm font-medium text-foreground">{user.full_name || user.email}</p>
                {user.full_name && <p className="text-xs text-foreground-muted">{user.email}</p>}
              </div>
            )}
            {!isRespondent && (
              <Link
                to="/organizations"
                onClick={() => setMenuOpen(false)}
                className="block px-3 py-2 rounded text-sm text-foreground-muted hover:text-foreground hover:bg-background-alt transition-colors"
              >
                <FormattedMessage id="nav.organizations" />
              </Link>
            )}
            <Link
              to="/settings/notifications"
              onClick={() => setMenuOpen(false)}
              className="block px-3 py-2 rounded text-sm text-foreground-muted hover:text-foreground hover:bg-background-alt transition-colors"
            >
              <FormattedMessage id="nav.notificationSettings" />
            </Link>
            <div className="px-3 py-2">
              <LanguagePicker />
            </div>
            <button
              onClick={() => { setMenuOpen(false); logout() }}
              className="block w-full text-left px-3 py-2 rounded text-sm text-foreground-muted hover:text-foreground hover:bg-background-alt transition-colors"
            >
              <FormattedMessage id="nav.signOut" />
            </button>
          </div>
        </div>
      )}
    </nav>
  )
}
